import { weChatrequest } from '@/utils/request'

const baseUrl = '/api/v1/alarm/thresholdRule'

export const getThresholdRulePage = data => weChatrequest({ url: `${ baseUrl }/page`, method: 'post', data })
export const getThresholdIndicatorOptions = () => weChatrequest({ url: `${ baseUrl }/indicatorOptions`, method: 'get' })
export const getThresholdAlarmOptions = () => weChatrequest({ url: `${ baseUrl }/alarmOptions`, method: 'get' })
export const addThresholdRule = data => weChatrequest({ url: baseUrl, method: 'post', data })
export const updateThresholdRule = data => weChatrequest({ url: baseUrl, method: 'put', data })
export const deleteThresholdRule = id => weChatrequest({ url: `${ baseUrl }/${ id }`, method: 'delete' })
export const updateThresholdRuleStatus = (id, status) => weChatrequest({
  url: `${ baseUrl }/${ id }/status/${ status }`,
  method: 'put'
})
